import axios from 'axios';

/**
 * Create an axios instance with authentication headers
 * This is needed for mobile browsers where cookies may not be sent
 */
export const createAuthenticatedAxios = () => {
  const instance = axios.create();
  
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('session_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.withCredentials = true;
    return config;
  });
  
  return instance;
};

// Pre-configured authenticated axios instance
export const authAxios = createAuthenticatedAxios();

/**
 * Helper to make authenticated API calls
 * @param {string} url - API endpoint
 * @param {object} options - Axios options
 */
export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem('session_token');
  const headers = {
    ...options.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
  
  return axios({
    ...options,
    url,
    headers,
    withCredentials: true
  });
};

/**
 * Store session token in localStorage
 */
export const setSessionToken = (token) => {
  if (token) {
    localStorage.setItem('session_token', token);
  } else {
    localStorage.removeItem('session_token');
  }
};

/**
 * Get session token from localStorage
 */
export const getSessionToken = () => localStorage.getItem('session_token');

/**
 * Clear session token from localStorage
 */
export const clearSessionToken = () => localStorage.removeItem('session_token');
